import { ConfirmEmailForm } from '@features/auth/confirm-email';

const ConfirmEmailPage = ConfirmEmailForm;

export { ConfirmEmailPage };
